module.exports = "/../../dist/frontend/images/agency-pin-unavailable.png?2444d737bf0fbc2716e2a31759d3637e";